import styles from './login.module.css';
import {Button, Col, Flex, Input, Row, Space, Typography} from 'antd';
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../../context/AppAuthContext";
import {KeyOutlined, MailOutlined} from "@ant-design/icons";
import Loader from "../../components/loader/loader";
import {useApp} from "../../context/AppDataContext";

// TODO: CREATE FORGET PASSWORD LOGIC
// TODO: ADD BACKGROUND TO LOGIN MOBILE VERSION
export default function Login() {
    const {isAuthenticated, login} = useAuth();
    const {isLoading, error} = useApp();
    const navigate = useNavigate();


    // IF THE USER IS ALREADY LOGGED IN THEN GO TO LANDING
    useEffect(() => {
        if (isAuthenticated) {
            navigate("/", {replace: true});
        }
    }, [isAuthenticated, navigate]);

    function handleGoSignUp() {
        navigate("/signup");
    }


    return (
        <>
            {isLoading && <Loader/>}
            <Row className={styles.login_structure}>
                <img
                    src="/resources/images/backgrounds/login_poster_2.png"
                    className={styles.mobile_bg}
                    alt="Background"
                    draggable={false}
                />
                <Col xs={0} md={12} span={14}>
                    <div className={styles.login_poster_container}>
                        <img className={styles.login_poster} src={"./resources/images/backgrounds/login_poster_2.png"}
                             alt="Tbadil"
                             draggable={false}
                        />
                    </div>
                </Col>
                <Col xs={24} md={12} span={12}>
                    <LoginForm error={error} login={login} handleGoSignUp={handleGoSignUp}/>
                </Col>
            </Row>
        </>
    )
}


function LoginForm({error, login, handleGoSignUp}) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();

    function handleGoLanding() {
        navigate("/");
    }

    function handleLogin() {
        if (email.length === 0 || password.length === 0) {
            error("Please enter your email and password");
            return;
        }
        // EMAIL CHECK
        // if (!email.includes('@') || !email.includes('.')) {
        //     error("Please enter a valid email address");
        //     return;
        // }
        // PASSWORD CHECK
        // if (password.length < 8) {
        //     error("Password must be at least 8 characters");
        //     return;
        // }
        // if (!/\d/.test(password)) {
        //     error("Password must contain numeric characters");
        //     return;
        // }
        login(email, password);
    }

    function handleKeyDown(e) {
        if (e.key === 'Enter') {
            handleLogin();
        }
    }

    return (
        <div className={styles.login}>
            <Space direction="vertical" style={{width: '100%'}}>
                <Flex justify="space-between">
                    <p className={styles.login_title}>Sign in</p>
                    <img className={styles.logo} src={"./resources/images/logo/logo.png"} alt="Tbadil"
                         onClick={handleGoLanding} draggable={false}/>
                </Flex>
                <Space direction="vertical" style={{width: '100%', marginTop: '30px'}}>
                    <Row>
                        <p style={{fontFamily: "'Rowdies', sans-serif", fontSize: "15px"}}>Email</p>
                    </Row>
                    <Row>
                        <Input onChange={(e) => setEmail(e.target.value)} autoFocus size="large"
                               placeholder="your@email.com" prefix={<MailOutlined/>}
                               onKeyDown={handleKeyDown}
                        />
                    </Row>
                    <Row>
                        <Flex justify="space-between" style={{width: '100%'}}>
                            <p style={{fontFamily: "'Rowdies', sans-serif", fontSize: "15px"}}>Password</p>
                            <Typography.Link>Forgot Password?</Typography.Link>
                        </Flex>
                    </Row>
                    <Row>
                        <Input.Password onChange={(e) => setPassword(e.target.value)}
                                        size="large" placeholder="******************" prefix={<KeyOutlined/>}
                                        onKeyDown={handleKeyDown}
                        />
                    </Row>
                    <Row>
                        <Button type="primary" htmlType={"submit"} className={styles.login_buttons}
                                onClick={handleLogin}
                        >
                            Sign in
                        </Button>
                    </Row>
                    <Row>
                        <p className={styles.signup_text}>
                            Don't have an account? <Typography.Link onClick={handleGoSignUp}>Sign up</Typography.Link>
                        </p>
                    </Row>
                </Space>
            </Space>
        </div>
    )
}